import React from 'react'
import { Link } from 'gatsby'

import { TrademarkSafeTitle } from 'util/titleParser'
import PlaceHolderImage from 'components/PlaceholderImage'
import Skeleton from 'components/Skeleton'

import './LinkCards.scss'

const LinkCards = ({ title, imageId, buttonCopy, buttonUrl }) => {
  return (
    <div className={`linkcard`} key={imageId}>
      <figure className="linkcard__img">
        {imageId ? (
          <PlaceHolderImage
            src={`${process.env.SITE_ASSET_URL}/${imageId}`}
            alt={title}
            width={312}
            height={160}
          />
        ) : (
          <Skeleton width={'100%'} height={160} />
        )}
      </figure>
      <div className="linkcard__details">
        <div className="body">{title}</div>
        {buttonCopy && (
          <a href={buttonUrl} className="cta">
            {buttonCopy}
          </a>
        )}
      </div>
    </div>
  )
}

export default LinkCards
